import "../../styles/LoaderSkeleton.scss"

export function LoaderSkeleton() {
    return(
        <div>
             <div className="skeleton"></div>
        </div>
    )
}